import { type Control, useWatch } from 'react-hook-form';
import { Button, CircularProgress } from '@mui/material';

import { PageHeader } from '@components/PageHeader';
import { type BatchSchema, type ProjectSchema } from '@/zod_schemas';

interface ProjectHeaderProps {
  control: Control<BatchSchema | ProjectSchema>; // Use union type here
  isSubmitting: boolean;
  project_type?: string;
  btn_name?: string;
}

const ProjectHeader = ({
  control,
  isSubmitting,
  project_type,
  btn_name,
}: ProjectHeaderProps) => {
  const name = useWatch({
    control: control as Control<BatchSchema | ProjectSchema>, // Use union type here
    name: 'name',
  });

  const projectType = project_type ? 'New Batch' : 'New Project';
  const btnName = btn_name || 'Save';

  return (
    <PageHeader
      eyebrow={project_type ? 'Batch configuration' : 'Project workspace'}
      title={name || projectType}
      description={
        project_type
          ? 'Configure the batch and the experiments included in this run.'
          : 'Capture project details, define experiments, and attach the samples required for analysis.'
      }
      actions={
        <Button type="submit" variant="contained" disabled={isSubmitting}>
          {isSubmitting ? (
            <CircularProgress size={22} color="inherit" />
          ) : (
            btnName
          )}
        </Button>
      }
    />
  );
};

export default ProjectHeader;
